let DEMO_ACCOUNT_ID = parseInt(process.env.REACT_APP_DEMO_ACCOUNT_ID);
let PAYPLUS_URL = process.env.REACT_APP_PAYPLUS_URL;

switch (window.location.host) {
  case 'ticket.laddit.io':
    DEMO_ACCOUNT_ID = 11911;
    PAYPLUS_URL = 'https://pay.laddition.com/pay';
    break;
  case 'ticket.laddition.com':
    DEMO_ACCOUNT_ID = 5;
    PAYPLUS_URL = 'https://payplus.laddition.com/pay';
    break;
}

export { DEMO_ACCOUNT_ID, PAYPLUS_URL };
